<template>
  <v-layout column wrap style="overflow: hidden;">
    <v-toolbar dark class="toolbarcreatedadmin" style="margin-top: 20px;">
      <img :src="BASE_URL + 'static/icon/qrcode.svg'" alt="" width="40px"> &nbsp;&nbsp;
      <v-toolbar-title>ข้อมูล QR Code</v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="hidden-sm-and-down">
        <v-text-field
          hide-details
          solo
          v-model="search"
          append-icon="search"
          label="ค้นหาจากGeneration ID หรือ S/N"
          class="textfieldSearch"
        ></v-text-field>
      </div>
    </v-toolbar>

    <div class="hidden-md-and-up">
        <v-text-field
        hide-details
          solo
          v-model="search"
          append-icon="search"
          label="ค้นหาจากGeneration ID หรือ S/N"
          class="textfieldSearch"
        ></v-text-field>
      </div>


    <v-layout class="pb-4" row wrap justify-center align-center style="margin-top: 20px;">
      <v-data-table
        :headers="headers"
        :items="listQrcodePaginated"
        :items-per-page="limit"
        hide-default-footer
        :loading="table_loading"
        class="elevation-1 mx-4 data-table-container"
        style="cursor: pointer; width: 100%;"
        height="450px"
        fixed-header
      >
        <template v-slot:item.generate_id="{ item }">
          📎 <span class="genpdf" @click="opennewTab('information_qrcode?id='+item.generate_id)">{{item.generate_id}} ({{item.qrcode_data.length}})</span>
        </template> 
        <template v-slot:item.serial_number="{ item }">
          <span >{{(item.qrcode_data.length==1 &&  item.qrcode_data[0].serial_number)? item.qrcode_data[0].serial_number:"-"}}</span>
        </template> 
        <template v-slot:item.create_at="{ item }">
          {{ dateMoment(item.create_at)}} - {{ timeMoment(item.create_at)}}น.
        </template>
        <template v-slot:item.create_by="{ item }">
          {{(item.create_by == 'null null')? '-':item.create_by }}
        </template>
        <template v-slot:loading>
          <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
        </template>
      </v-data-table>
    <v-pagination color="#a81000" v-model="page_pagination" :total-visible="7" :length="total_page"></v-pagination>
    </v-layout>
  </v-layout>
</template>
<script>
var _ = require('lodash')
import { Decode, Momenttime } from '@/services'
export default {
  data () {
    return {
    BASE_URL: process.env.BASE_URL,
    items: [],
    itemsselect: [],
    search: '',
    headers: [
      { text: 'Generate ID', value: 'generate_id' },
      { text: 'เจ้าของ', value: 'company_owner_name' ,filterable: true},
      { text: 'หน่วยงานที่ดูแล', value: 'company_maintenance_name' },
      { text: 'Serial No.', value: 'serial_number'},
      { text: 'วันเวลาที่สร้าง', value: 'create_at' },
      { text: 'สร้างโดย', value: 'create_by' }
    ],
    listQrcode: [],
    page_pagination: 1,
    limit: 10,
    total_page: 0,
    table_loading: false
  }},
  created () {
    this.getlistQrcode()
  },
  watch: {
    page_pagination () {
      // คำนวณข้อมูลที่จะแสดงตาม page
    },
    search () {
      this.page_pagination = 1
    }
  },
  computed: {
    listQrcodePaginated () {
      // คำนวณ total_page
      this.total_page = Math.ceil(this.listQrcodeFile.length / this.limit)

      // คำนวณข้อมูลที่จะแสดงตาม pagination
      const start = (this.page_pagination - 1) * this.limit
      const end = start + this.limit
      return this.listQrcodeFile.slice(start, end)
    },
    listQrcodeFile () {
      if (this.search !== '' && this.search !== null) {
        return this.listQrcode.filter(post => {
          try {
            return post.company_owner_name.toLowerCase().includes(this.search.toLowerCase()) || post.company_maintenance_name.toLowerCase().includes(this.search.toLowerCase()) || post.generate_id.toLowerCase().includes(this.search.toLowerCase()) || post.qrcode_data.find(post2 => {
                try {
                  // console.log(post2.serial_number.toLowerCase().includes(this.search.toLowerCase()) )
                  return post2.serial_number.toLowerCase().includes(this.search.toLowerCase())
                } catch(err) {
                }
              })
          } catch(err) {
          }
        })
      } else {
        return this.listQrcode
      }
    }
  },
  methods: {
    opennewTab (link) {
      // window.open(link)
      // this.$router.push(link)
      window.open(this.BASE_URL + link, '_blank')
    },
    dateMoment(data) {
      return Momenttime.momentdatethai(data)
    },
    timeMoment(data) {
      return Momenttime.momenttimethai(data)
    },
    getlistQrcode () {
      this.table_loading = true
      this.$api.getListGenerateQrCode().then((response) => {
        this.listQrcode = response.data.data
        this.listQrcode = _.sortBy(this.listQrcode, function (dateObj) {
          return new Date(dateObj.create_at)
        }).reverse()
        // console.log(this.listQrcode)
        this.table_loading = false
      })
    }
  }
}
</script>
<style media="screen" scoped>
/* >>>.v-textarea.v-text-field--full-width .v-text-field__slot .textarea {
  margin-top: 10px !important;
} */
  >>>.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot {
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
  }
  .inputinfor_address {
    height: 110px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: white !important;
  }
  .inputinfor {
    height: 50px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: white !important;
  }
  .inputinfor_dis {
    height: 50px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: #FAF0F0 !important;
  }
  >>>.theme--dark.v-select .v-select__selections {
    color: #a80e00 !important;
  }
  >>>.theme--dark.v-label {
    color: hsl(5, 100%, 33%) !important;
  }
  >>>.theme--dark.v-icon {
    color: #a80e00 !important;
  }
  >>>.theme--dark.v-input:not(.v-input--is-disabled) input {
    color: #a80e00 !important;
  }
  >>>.v-select__selections {
    line-height: 26px !important;
  }
  >>>.v-select__selection--comma {
    color: #a80e00 !important;
  }
  >>>.v-input .v-label {
    height: 26px;
    line-height: 26px;
  }
  >>>.v-list-item__title {
    line-height: 26px !important;
  }
  .toolbarcreatedadmin {
    border-top-color: transparent !important;
    border-left-color: transparent !important;
    border-width: thin !important;
    border-right-color: transparent !important;
    border-style: solid !important;
    height: 64px !important;
    border-left-style: initial !important;
    border-right-style: initial !important;
    border-radius: 0px !important;
    border-bottom-color: #a80e00 !important;
    background-color: white !important;
    color: #a80e00 !important;
    border-width: thin !important;
    box-shadow: none !important;
  }
  .btngen {
    background-color: white !important;
    color: #a80f00 !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    text-transform: none !important;
    width: 120px !important;
  }
  .btncreateuser {
    background-color: #a80f00 !important;
    color: #fafafa !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    text-transform: none !important;
  }
  .btncreateuser:disabled {
    background-color: #a80f0099 !important;
    color: #fafafa9c !important;
    border-color: #a80f0091 !important;
    border-style: solid !important;
    border-width: thin !important;
  }

  .btncancle {
    background-color: #fafafa !important;
    color: #a80f00 !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    width: 160px !important;
  }
  .genpdf {
    cursor: pointer;  
  }
  .genpdf:hover {
    color: #a80d00;  
    text-decoration: underline;
  }
>>>.theme--light.v-data-table thead tr:last-child th {
    border-bottom: thin solid rgba(0,0,0,.12);
    background: #a80e00 !important;
    color: white !important;
}
>>>.v-data-table__wrapper {
    border-radius: 14px;
    overflow-x: auto;
}

>>>.data-table-container {
    width: 100%;
    max-width: 100%;
}

>>>.theme--light.v-data-table {
    border-radius: 14px !important;
    margin-bottom: 20px !important;
}

.textfieldSearch {
  width: 330px;
  display: -webkit-inline-box;
  margin-right: 20px;
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px), (min-width: 768px) and (max-width: 1024px)  {
  .textfieldSearch {
    width: 80vw;
    margin-top: 20px;
    display: -webkit-inline-box;
    margin-right: 20px;
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
  }
}

>>>.primary {
    background-color: #a81000 !important;
    border-color: #a81000 !important;
}

>>>.theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #ffe6e6 !important;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/listReport/Listqrcode.vue